import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import { AssinaturasVencer } from 'ebs-orders-reports-react-lib';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';

export default class ExpiringOrders extends Component {

    constructor() {
        super();

        this.Configurations = new Configurations();
        this.getAssinaturasVencer = this.getAssinaturasVencer.bind(this);
        this.handleOrg = this.handleOrg.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.state = {
            hasError: false,
            errorMessage: '',
            listaAssinaturas: []
        };
    }

    getAssinaturasVencer() {
        this.setState({ isLoading: true }, () => {
            const _service = axios.get(this.Configurations.apiBasePath + "/relatorio/assinaturas/assinaturas-a-vencer?organizacao=" + (this.state.orgSelecionada));

            _service.then(response => {
                const _resp = response.data.AssinaturasVencer;
                this.setState({
                    resumoAssinaturas: _resp.resumo,
                    listaAssinaturas: _resp.nominal
                })
            }).catch(this.handleError).finally(() => this.setState({ isLoading: false }))
        });
    }

    handleOrg(eValue) {
        this.setState({ isLoading: true, orgSelecionada: eValue, flagBusca: true },
            () => {
                this.getAssinaturasVencer();
            }
        );
    }

    handleError(err) { this.setState({ hasError: true, errorMessage: err.message }) }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    render() {

        const {
            isLoading, flagBusca,
            resumoAssinaturas,
            listaAssinaturas,
            orgSelecionada,
            hasError, errorMessage
        } = this.state;

        return (
            <div className="carriers-list">
                <AssinaturasVencer
                    handleOrg={this.handleOrg}
                    orgSelecionada={orgSelecionada}
                    isLoading={isLoading}
                    flagBusca={flagBusca}
                    resumoAssinaturas={resumoAssinaturas}
                    listaAssinaturas={listaAssinaturas}
                    apiBasePath={this.Configurations.apiBasePath}
                    tokenKey={this.Configurations.tokenKey}
                />
                <ErrorModal isOpen={hasError} message={errorMessage} closeErrorModal={this.closeErrorModal} />
            </div>
        )
    }
}
